export type UserRole =
  | 'operador'
  | 'supervisor'
  | 'gerente'
  | 'administrador';

export const ROLES: Record<Uppercase<UserRole>, UserRole> = {
  OPERADOR: 'operador',
  SUPERVISOR: 'supervisor',
  GERENTE: 'gerente',
  ADMINISTRADOR: 'administrador',
};